import React from 'react'
import { useBrandingColors } from 'hooks/useBrandingColors'

export const FlagIconTransparent = ({ isActive }: { isActive: boolean }) => {
  const { icon } = useBrandingColors()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="52.65"
      height="58.673"
      viewBox="0 0 52.65 58.673"
    >
      <defs>
        <clipPath id="clip-path-flag-tp">
          <path
            id="Контур_160"
            data-name="Контур 160"
            d="M44.506,13.375l13.163,7.87A13.646,13.646,0,0,1,64.25,32.992v15.74a13.5,13.5,0,0,1-6.581,11.746l-13.163,7.87a12.63,12.63,0,0,1-13.162,0l-13.163-7.87A13.646,13.646,0,0,1,11.6,48.732V32.992a13.5,13.5,0,0,1,6.581-11.746l13.163-7.87A12.631,12.631,0,0,1,44.506,13.375Z"
            transform="translate(-11.6 -11.525)"
          />
        </clipPath>
      </defs>
      <g
        id="Сгруппировать_4587"
        data-name="Сгруппировать 4587"
        transform="translate(-168.393 -146)"
      >
        <g
          id="Сгруппировать_2756"
          data-name="Сгруппировать 2756"
          transform="translate(168.393 146)"
        >
          <g
            id="Сгруппировать_53"
            data-name="Сгруппировать 53"
            transform="translate(0 0)"
            clipPath="url(#clip-path-flag-tp)"
          >
            <rect
              id="Прямоугольник_7"
              data-name="Прямоугольник 7"
              width="64.637"
              height="70.478"
              transform="translate(-5.994 -5.903)"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
              strokeWidth="1"
            />
          </g>
          <path
            id="Контур_161"
            data-name="Контур 161"
            d="M44.506,13.375l13.163,7.87A13.646,13.646,0,0,1,64.25,32.992v15.74a13.5,13.5,0,0,1-6.581,11.746l-13.163,7.87a12.63,12.63,0,0,1-13.162,0l-13.163-7.87A13.646,13.646,0,0,1,11.6,48.732V32.992a13.5,13.5,0,0,1,6.581-11.746l13.163-7.87A12.631,12.631,0,0,1,44.506,13.375Z"
            transform="translate(-11.6 -11.525)"
            fill="#fff"
            opacity={isActive ? '1' : '0.5'}
          />
        </g>
        <g
          id="Сгруппировать_3142"
          data-name="Сгруппировать 3142"
          transform="translate(1336.874 -583.431)"
        >
          <path
            id="Контур_7902"
            data-name="Контур 7902"
            d="M-1126.628,754.756q-3.416-7.5-6.857-14.981c-.048-.1-.107-.2-.185-.343-.121.247-.211.433-.3.617a6.386,6.386,0,0,1-2.91,2.959,11.066,11.066,0,0,1-4.376.963c-2.082.116-4.173.147-6.246.357a6.068,6.068,0,0,0-4.275,2.2,23.155,23.155,0,0,0-1.315,2.031.427.427,0,0,1-.064-.071c-.042-.055-.074-.118-.116-.171a2.112,2.112,0,0,0-2.158-.739,1.7,1.7,0,0,0-1.343,1.32,2.367,2.367,0,0,0,.156,1.732q5.759,12.205,11.507,24.416c.452.961.887,1.931,1.363,2.881a2.082,2.082,0,0,0,3.194.695,2.276,2.276,0,0,0,.4-2.572q-2.716-5.767-5.441-11.53a.763.763,0,0,1,0-.736,6.477,6.477,0,0,1,4.025-3.465,18.7,18.7,0,0,1,4.878-.585c1.477-.059,2.96-.086,4.423-.265a6.63,6.63,0,0,0,5.645-4.1.838.838,0,0,0,0-.611m-23.435-1.22a.77.77,0,0,1-.708-.466l-.885-2.077a.76.76,0,0,1-.007-.588.759.759,0,0,1,.412-.42l2.075-.886a.769.769,0,0,1,1.008.4l.886,2.077a.766.766,0,0,1,.007.588.763.763,0,0,1-.412.42l-2.077.886a.765.765,0,0,1-.3.061m5.89,5.054a.757.757,0,0,1-.41.42l-2.077.886a.747.747,0,0,1-.3.062.769.769,0,0,1-.707-.466l-.886-2.075a.769.769,0,0,1,.4-1.008l2.077-.886a.769.769,0,0,1,1.008.4l.886,2.077a.763.763,0,0,1,.005.587m2.393-4.7-2.077.886a.757.757,0,0,1-.3.062.785.785,0,0,1-.286-.055.771.771,0,0,1-.421-.412l-.886-2.077a.77.77,0,0,1,.406-1.008l2.075-.885a.761.761,0,0,1,.588-.007.759.759,0,0,1,.42.412l.886,2.075a.769.769,0,0,1-.4,1.008m.247-4.048a.758.758,0,0,1-.286-.056.763.763,0,0,1-.421-.41l-.886-2.077a.769.769,0,0,1,.4-1.008l2.077-.886a.769.769,0,0,1,1.008.4l.886,2.077a.77.77,0,0,1-.4,1.008l-2.077.886a.763.763,0,0,1-.3.061m5.892,5.054a.762.762,0,0,1-.412.421l-2.075.885a.776.776,0,0,1-.3.062.769.769,0,0,1-.707-.466l-.886-2.075a.766.766,0,0,1-.007-.588.763.763,0,0,1,.412-.42l2.077-.886a.768.768,0,0,1,1.008.4l.885,2.075a.76.76,0,0,1,.007.588m.017-3.748a.77.77,0,0,1-.708-.466l-.886-2.077a.763.763,0,0,1-.005-.587.764.764,0,0,1,.41-.421l2.077-.886a.769.769,0,0,1,1.008.406l.886,2.075a.766.766,0,0,1,.007.588.768.768,0,0,1-.412.42h0l-2.077.886a.765.765,0,0,1-.3.061m5.937,4.939a.763.763,0,0,1-.412.42l-2.075.886a.775.775,0,0,1-.3.061.767.767,0,0,1-.707-.466l-.886-2.075a.769.769,0,0,1,.4-1.009l2.075-.885a.76.76,0,0,1,.588-.007.759.759,0,0,1,.42.412l.886,2.075a.767.767,0,0,1,.007.588"
            transform="translate(0 0)"
            fill={isActive ? icon : '#fff'}
          />
        </g>
      </g>
    </svg>
  )
}
